import React from "react";
import { withRouter } from "react-router-dom";
import {
    handleDownloadMultipleFiles,
    handleDeleteFilePermanently,
    handleMarkAsDeleted,
    handleMarkAsActived,
    handleReprocessFile,
    handleSendSalesInformationEmail,
    handleRequestMergeFromMergeCollisions,
    handleFileSubmissionSubmission,
    handleDeleteGeneratorFileEntry,
} from "./DatagridHandleUserActions";
import {
    SovosDivider,
    SovosIconMenu,
    SovosListItemIcon,
    SovosListItemText,
    SovosMenuItem,
    SovosToolbarBulkActions,
    SovosTypography,
} from "mosaic-react";
import {
    Download,
    Delete,
    Task,
    MoreVert,
    DocumentErrorFilled,
    WifiProtectedSetupOutlined,
    Drafts,
    Merge,
    Upload,
} from "mosaic-react-icons";
import {
    pushModal,
    pushDialog,
    auditNoteSubmit,
    setDataFileStatusAction,
    saveWorkerAssociationPackageAction,
    deleteFilePermanentlyAction,
    deleteInvalidFilePermanentlyAction,
    hideFileAction,
    reprocessRepositoryAction,
    requestDataForOrganizationsAction,
    uploadAction,
    downloadAction,
    handleDownloadFilesAction,
    reprocessFileAction,
    sendSalesInformationEmail,
    deleteGeneratorFileEntryAction,
    downloadCsvStreamAction,
} from "../../store/actions";
import { connect } from "react-redux";
import { UserRoles } from "../../enums/userRoles";
import I18n from "../../I18n";
import { checkRolesByOrganizationProject, checkRoles } from "colbi_web_ui/lib/utils/roleValidator";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { SovosButton } from "mosaic-react";

const DatagridUserActions = (props) => {
    const { modules, params, user, repositoryStatus, i18n, reload, pushNotification } =
        useGlobalValue();
    const { rowsSelectedIds: selectedFiles } = props;
    if (params.section) {
        switch (params.section) {
            case "folders":
                return RepositoryFoldersActions({
                    ...props,
                    selectedFiles,
                    modules,
                    user,
                    repositoryStatus,
                    i18n,
                    params,
                    pushNotification,
                });
            case "invalid_files":
                return RepositoryInvalidFiles({
                    ...props,
                    selectedFiles,
                    params,
                    user,
                    repositoryStatus,
                    i18n,
                    pushNotification,
                });
            case "merge_collisions":
                return MergeRepositoryMetadata({
                    ...props,
                    params,
                    user,
                    i18n,
                    reload,
                    pushNotification,
                });
            case "submission_saft":
                return FileSubmissionButton({
                    ...props,
                    selectedFiles,
                    i18n,
                    reload,
                    params,
                    pushNotification,
                });
            case "generation":
                return GenerationFilesActions({ ...props, selectedFiles, params, user, i18n });
            default:
                break;
        }
    }

    return null;
};

const MergeRepositoryMetadata = (props, pushNotification) => {
    const { i18n, params, reprocessRepository, user, pushDialog, reload } = props;
    return (
        <div
            style={{
                float: "right",
                order: 1,
                display: "flex",
                flex: 1,
                justifyContent: "flex-end",
            }}
        >
            <SovosButton
                startIcon={<Merge />}
                size="medium"
                variant="text"
                onClick={() => {
                    handleRequestMergeFromMergeCollisions({
                        pushDialog,
                        i18n,
                        params,
                        reprocessRepository,
                        user,
                        pushNotification,
                        reload,
                    });
                }}
                children={i18n`Merge Repo Metadata`}
            />
        </div>
    );
};

const RepositoryInvalidFiles = (props) => {
    const { user, i18n, params, count } = props;
    const { projectId } = params || {};
    const { pushNotification } = useGlobalValue();

    const validateUser = checkRolesByOrganizationProject(user, projectId, [
        UserRoles.ADMIN,
        UserRoles.OWNER,
        UserRoles.PP_SUPPORT,
        UserRoles.SUPPORT,
    ]);

    return (
        validateUser && (
            <SovosToolbarBulkActions count={count}>
                <SovosIconMenu iconElement={<MoreVert />}>
                    <SovosMenuItem
                        onClick={() => {
                            handleDownloadMultipleFiles(props, pushNotification, projectId);
                        }}
                    >
                        <SovosListItemIcon>
                            <Download />
                        </SovosListItemIcon>
                        <SovosListItemText>
                            <span>{i18n`Download`}</span>
                        </SovosListItemText>
                    </SovosMenuItem>
                    <SovosMenuItem
                        onClick={() => {
                            handleDeleteFilePermanently(props, pushNotification);
                        }}
                    >
                        <SovosListItemIcon>
                            <Delete />
                        </SovosListItemIcon>
                        <SovosListItemText>
                            <span>{i18n`Delete`}</span>
                        </SovosListItemText>
                    </SovosMenuItem>
                </SovosIconMenu>
            </SovosToolbarBulkActions>
        )
    );
};
const RepositoryFoldersActions = (props) => {
    const { user, i18n, params, count, selectedFiles, modules, pushNotification } = props;

    const { projectId } = params || {};
    const validateUser = [
        UserRoles.ADMIN,
        UserRoles.OWNER,
        UserRoles.WRITER,
        UserRoles.PP_SUPPORT,
        UserRoles.SUPPORT,
    ].includes(user.role);
    const validateUserRolesByProject = checkRolesByOrganizationProject(user, projectId, [
        UserRoles.ADMIN,
        UserRoles.OWNER,
        UserRoles.PP_SUPPORT,
        UserRoles.SUPPORT,
    ]);
    const extraProps = {};
    const repoStatus = props.repositoryStatus.repoStatus;
    if (repoStatus === 2) {
        extraProps.disabled = true;
    }

    if (!validateUser) {
        return;
    }

    const actionButtonsByRole = validateUserRolesByProject
        ? [
              <SovosMenuItem
                  {...extraProps}
                  onClick={() => handleMarkAsActived(props, pushNotification)}
                  key={0}
              >
                  <SovosListItemIcon>
                      <Task />
                  </SovosListItemIcon>
                  <SovosListItemText>
                      <span>{i18n`Activate`}</span>
                  </SovosListItemText>
              </SovosMenuItem>,
              <SovosMenuItem
                  {...extraProps}
                  onClick={() => handleMarkAsDeleted(props, pushNotification)}
                  key={1}
              >
                  <SovosListItemIcon>
                      <DocumentErrorFilled sx={{ path: { fill: "#545e75" } }} />
                  </SovosListItemIcon>
                  <SovosListItemText>
                      <span>{i18n`Deactivate`}</span>
                  </SovosListItemText>
              </SovosMenuItem>,
              <SovosDivider key={2} />,
              <SovosMenuItem
                  {...extraProps}
                  onClick={() => handleDeleteFilePermanently(props, pushNotification)}
                  key={3}
              >
                  <SovosListItemIcon>
                      <Delete />
                  </SovosListItemIcon>
                  <SovosListItemText>
                      <span>{i18n`Delete`}</span>
                  </SovosListItemText>
              </SovosMenuItem>,
          ]
        : null;
    return (
        <SovosToolbarBulkActions count={count}>
            <SovosIconMenu iconElement={<MoreVert />}>
                <SovosMenuItem
                    //TODO: Why we need this extra props here?
                    {...extraProps}
                    onClick={() => {
                        handleDownloadMultipleFiles(props, pushNotification, projectId);
                    }}
                >
                    <SovosListItemIcon>
                        <Download />
                    </SovosListItemIcon>
                    <SovosListItemText>
                        <span>{i18n`Download`}</span>
                    </SovosListItemText>
                </SovosMenuItem>
                {checkRoles(user, [UserRoles.ADMIN, UserRoles.SUPPORT, UserRoles.PP_SUPPORT]) ? (
                    <SovosMenuItem
                        {...extraProps}
                        onClick={() => handleReprocessFile(props, pushNotification)}
                    >
                        <SovosListItemIcon>
                            <WifiProtectedSetupOutlined />
                        </SovosListItemIcon>
                        <SovosListItemText>
                            <span>{i18n`Reprocess`}</span>
                        </SovosListItemText>
                    </SovosMenuItem>
                ) : null}
                {!checkRoles(user, [UserRoles.READER]) &&
                (modules || []).includes("submission_file") ? (
                    <SovosMenuItem
                        onClick={() => {
                            const validateFiles =
                                selectedFiles.filter(
                                    (x) => x.status !== "imported" || x.internalStatus === 1,
                                ) || [];
                            if (validateFiles && validateFiles.length > 0) {
                                pushNotification({
                                    open: true,
                                    message: I18n.translate`Select files that have not yet been imported and submitted!`,
                                    type: "error",
                                    timeout: "short",
                                });
                            } else {
                                handleSendSalesInformationEmail(props, pushNotification);
                            }
                        }}
                        {...extraProps}
                    >
                        <SovosListItemIcon>
                            <Drafts />
                        </SovosListItemIcon>
                        <SovosListItemText>
                            <span>{i18n`Submit File`}</span>
                        </SovosListItemText>
                    </SovosMenuItem>
                ) : null}
                {actionButtonsByRole}
            </SovosIconMenu>
        </SovosToolbarBulkActions>
    );
};

const FileSubmissionButton = (props) => {
    const { i18n, selectedFiles, params, pushModal, pushNotification } = props;
    return (
        <div
            style={{
                float: "right",
                order: 1,
                display: "flex",
                flex: 1,
                justifyContent: "flex-end",
            }}
        >
            <SovosButton
                startIcon={<Upload />}
                size="medium"
                variant="text"
                onClick={() => {
                    if (selectedFiles && selectedFiles.length === 0) {
                        pushNotification({
                            open: true,
                            message: i18n`Please Select Files to Submit!`,
                            type: "error",
                            timeout: "short",
                        });
                    } else {
                        handleFileSubmissionSubmission({
                            checkList: selectedFiles,
                            i18n,
                            params,
                            pushModal,
                            pushNotification,
                        });
                    }
                }}
                children={i18n`SAF-T Submission`}
            />
        </div>
    );
};

const GenerationFilesActions = (props) => {
    const { user, i18n, params, count } = props;
    const { projectId } = params || {};
    const { pushNotification } = useGlobalValue();

    const validateUser = checkRolesByOrganizationProject(user, projectId, [
        UserRoles.ADMIN,
        UserRoles.OWNER,
        UserRoles.PP_SUPPORT,
        UserRoles.SUPPORT,
    ]);
    return (
        validateUser && (
            <SovosToolbarBulkActions count={count}>
                <SovosIconMenu iconElement={<MoreVert />}>
                    <SovosMenuItem
                        onClick={() => {
                            handleDeleteGeneratorFileEntry(props, pushNotification);
                        }}
                    >
                        <SovosListItemIcon>
                            <Delete />
                        </SovosListItemIcon>
                        <SovosListItemText>
                            <SovosTypography children={i18n`Delete`} variant={"span"} />
                        </SovosListItemText>
                    </SovosMenuItem>
                </SovosIconMenu>
            </SovosToolbarBulkActions>
        )
    );
};
export default connect(
    ({ fetch, menu, uploads }) => ({
        fetch,
        menu,
        uploads,
    }),
    {
        pushModal,
        pushDialog,
        setDataFileStatus: setDataFileStatusAction,
        saveWorkerAssociationPackage: saveWorkerAssociationPackageAction,
        deleteFilePermanently: deleteFilePermanentlyAction,
        deleteGeneratorFileEntry: deleteGeneratorFileEntryAction,
        deleteInvalidFilePermanently: deleteInvalidFilePermanentlyAction,
        hideFile: hideFileAction,
        downloadFiles: handleDownloadFilesAction,
        reprocessRepository: reprocessRepositoryAction,
        requestDataForOrganizations: requestDataForOrganizationsAction,
        uploadFiles: uploadAction,
        download: downloadAction,
        submitAuditNote: auditNoteSubmit,
        reprocessFiles: reprocessFileAction,
        sendSalesInformationEmail,
        downloadCsvStreamAction: downloadCsvStreamAction
    },
)(withRouter(DatagridUserActions));
